module.exports = __webpack_public_path__ + "static/assets/logo.5a754575.png";